<script>
import { mapActions, mapState } from "vuex";
import cryptoRandomString from "crypto-random-string";
import compUmatSuami from "@/components/form/umatSuami";
import compUmatIstri from "@/components/form/umatIstri";
import compumatPerkawinan from "@/components/form/perkawinan";
import compUmatModal from "@/components/modal/umat";
import umatOpt from "@/data/umatOpt";

export default {
	name: "perkawinanForm",
	components: {
		"comp-umat-suami": compUmatSuami,
		"comp-umat-istri": compUmatIstri,
		"comp-umat-perkawinan": compumatPerkawinan,
		"comp-umat-modal": compUmatModal,
	},
	data() {
		return {
			mode: "INSERT",

			myOptions: {
				kriteria: umatOpt.kriteria,
				jk: umatOpt.jk,
				gol_darah: umatOpt.golDarah,
			},
			trigger: {
				suami: 0,
				istri: 0,
				perkawinan: 0,
			},
			radio: {
				suami: "baru",
				istri: "baru",
				relasi: true,
			},
			uid: {
				suami: "",
				istri: "",
				perkawinan: "",
			},
			dataManual: {},
		};
	},
	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
		...mapState({
			umatSuami: (state) => state.umat.suami,
			umatIstri: (state) => state.umat.istri,
			umatPerkawinanItem: (state) => state.umatPerkawinan.item,
			lingkunganStasi: (state) => state.service.lingkunganStasi,
		}),
		baruLama: function () {
			return Object.assign({}, this.radio);
		},
	},
	created() {
		this.$store.dispatch("umat/resetItemSuami");
		this.$store.dispatch("umat/resetItemIstri");
		this.$store.dispatch("umatPerkawinan/resetItem");

		if (typeof this.$route.params.id !== "undefined") {
			this.mode = "UPDATE";

			this.getItemPerkawinan(this.$route.params.id).then(
				(response) => {
					this.setItemSuami(response.data.suami);
					this.setItemIstri(response.data.istri);
					this.setItemPerkawinan(response.data.perkawinan);
               
               this.dataManual.nama_pasangan = response.data.perkawinan.nama_pasangan
					if (response.data.perkawinan.uid_pasangan) {
						this.radio.relasi = true;
                  this.radio.istri = "lama";
					} else {
						this.radio.relasi = false;
                  this.radio.istri = "baru";
					}
				},
				() => {
					this.$router.push("/perkawinan");
				}
			);
		} else {
			this.uid.suami = cryptoRandomString({
				length: 32,
				type: "distinguishable",
			});
			this.uid.istri = cryptoRandomString({
				length: 32,
				type: "distinguishable",
			});

			this.umatSuami.uid = this.uid.suami;
			this.umatIstri.uid = this.uid.istri;
			
		}
	},
	mounted() {
		this.getLingkunganStasi();
	},
	watch: {
		// eslint-disable-next-line no-unused-vars
		baruLama: {
			handler: function (val, oldVal) {
				if (val.suami !== oldVal.suami) {
					switch (val.suami) {
						case "baru":
							this.$store.dispatch("umat/resetItemSuami");
							this.umatSuami.uid = this.uid.suami;
							console.log("suami", "baru");

							break;
						case "lama":
							console.log("suami", "lama");
							console.log("suamiOld", oldVal.suami);
							break;
					}
				}

				if (val.istri !== oldVal.istri) {
					switch (val.istri) {
						case "baru":
							this.$store.dispatch("umat/resetItemIstri");
							this.umatIstri.uid = this.uid.istri;
							console.log("istri", "baru");
							break;
						case "lama":
							console.log("istri", "lama");
							break;
					}
				}
			},
			deep: true,
		},
	},
	methods: {
		...mapActions({
			insert: "umatPerkawinan/insert",
			update: "umatPerkawinan/update",
			getItemPerkawinan: "umatPerkawinan/getItem",
			setItemPerkawinan: "umatPerkawinan/setItem",
			setItemUmat: "umat/setItem",
			getItemUmat: "umat/getItem",
			setItemSuami: "umat/setItemSuami",
			setItemIstri: "umat/setItemIstri",
			getLingkunganStasi: "service/getLingkunganStasi",
		}),
		handleSumbmit() {
			this.trigger.suami = !this.trigger.suami;
			console.log("trigger Suami");
		},
		async validateSuami(result) {
			await result.then((valid) => {
				if (!valid) {
					this.$toast.error("Data Umat belum lengkap");
				} else {
					this.trigger.istri = !this.trigger.istri;
					console.log("trigger Istri");
				}
			});
		},
		async validateIstri(result) {
			await result.then((valid) => {
				if (!this.radio.relasi) {
               this.trigger.perkawinan = !this.trigger.perkawinan;
					return;
				}

				if (!valid) {
					this.$toast.error("Data Pasangan belum lengkap");
				} else {
					this.trigger.perkawinan = !this.trigger.perkawinan;
					console.log("trigger Perkawinan");
				}
			});
		},
		async validatePerkawinan(result) {
			await result.then((valid) => {
				if (!valid) {
					this.$toast.error("Data Perkawinan belum lengkap");
				} else {
					console.log("onSubmit");
					this.onSubmit();
				}
			});
		},
		onSubmit() {
         this.umatPerkawinanItem.uid = this.umatSuami.uid;
			this.umatPerkawinanItem.uid_suami = this.umatSuami.uid;
			this.umatPerkawinanItem.uid_istri = this.umatIstri.uid;
         
         
         if(this.radio.relasi){
            this.umatPerkawinanItem.uid_pasangan = this.umatIstri.uid;
            this.umatPerkawinanItem.nama_pasangan = this.umatIstri.nama
         }else{
            this.umatPerkawinanItem.uid_pasangan = null
            this.umatPerkawinanItem.nama_pasangan = this.dataManual.nama_pasangan
         }
         
			const data = {
				suami: this.umatSuami,
				istri: this.umatIstri,
				perkawinan: this.umatPerkawinanItem,
			};

			if (this.mode === "INSERT") {
				this.insert(data).then(() => {
					this.$router.push("/perkawinan");
				});
			} else {
				this.update(data).then(() => {
					this.$router.push("/perkawinan");
				});
			}
		},
		onCancelSuami() {
			this.radio.suami = "baru";
			this.$modal.hide("umatSuamiModal");
		},
		onRowClickSuami(uid) {
			this.getItemUmat(uid).then((response) => {
				const umat = response.data.umat;

				// CHECKING
				if (umat.is_perkawinan) {
					this.$toast.error("Umat ini sudah menikah.");
					return;
				}

				if (umat.jk !== "L") {
					this.$toast.error("Umat harus Laki-laki");
					return;
				}

				this.setItemSuami(umat);
				this.$modal.hide("umatSuamiModal");
			});
		},
		onShowUmatSuami() {
			this.radio.suami = "lama";
			this.$modal.show("umatSuamiModal");
		},
		onCancelIstri() {
			this.radio.istri = "baru";
			this.$modal.hide("umatIstriModal");
		},
		onRowClickIstri(uid) {
			this.getItemUmat(uid).then((response) => {
				const umat = response.data.umat;
            
            if (umat.is_perkawinan) {
					this.$toast.error("Umat ini sudah menikah.");
					return;
				}
                        
				if (umat.jk == this.umatSuami.jk) {
					this.$toast.error("Jenis Kelamin Pasangan harus berbeda dengan Data Umat");
					return;
				}

				this.setItemIstri(umat);
				this.$modal.hide("umatIstriModal");
			});
		},
		onShowUmatIstri() {
			this.radio.istri = "lama";
			this.$modal.show("umatIstriModal");
		},
		autoFill() {
			this.umatSuami.nama = this.$faker().name.findName();
			this.umatSuami.tempat_lahir = this.$faker().address.city();
			this.umatSuami.alamat = this.$faker().address.streetName();
			this.umatSuami.tgl_lahir = "2000-01-01";
			this.umatSuami.jk = "L";
			this.umatSuami.suku = "Dayak";
			this.umatSuami.keuskupan = "Keuskupan Sintang";
			this.umatSuami.paroki = "Paroki Kristus Raja Katedral Sintang";
			this.umatSuami.lingkungan_stasi = "Stasi Jerora 1";
			this.umatSuami.kabupaten = "Sintang";
			this.umatSuami.kecamatan = "Sintang  ";
			this.umatSuami.desa = "Jerora Satu";
			this.umatSuami.agama = "Katolik";
			this.umatSuami.pekerjaan = "Konsultan";
			this.umatSuami.pendidikan = "S1";
			this.umatSuami.jurusan = "Teknik Infomatika";
			this.umatSuami.nik = "61287318273";
			this.umatSuami.nohp = "081255225454";
			this.umatSuami.email = "Dayak@gmail.com";
			this.umatSuami.gol_darah = "O";
			this.umatSuami.aktivitas = "Warga Biasa";
			this.umatSuami.profesi = [{ text: "Guru", value: "Guru" }];
			this.umatSuami.keterampilan = [{ text: "Musik", value: "Musik" }];
			this.umatSuami.status_kawin = "Menikah";
			this.umatSuami.cacat_tubuh = "Tidak";

			this.umatIstri.nama = this.$faker().name.findName();
			this.umatIstri.tempat_lahir = this.$faker().address.city();
			this.umatIstri.alamat = this.$faker().address.streetName();
			this.umatIstri.tgl_lahir = "2000-01-01";
			this.umatIstri.jk = "P";
			this.umatIstri.suku = "Dayak";
			this.umatIstri.keuskupan = "Keuskupan Sintang";
			this.umatIstri.paroki = "Paroki Kristus Raja Katedral Sintang";
			this.umatIstri.lingkungan_stasi = "Stasi Jerora 1";
			this.umatIstri.kabupaten = "Sintang";
			this.umatIstri.kecamatan = "Sintang  ";
			this.umatIstri.desa = "Jerora Satu";
			this.umatIstri.agama = "Katolik";
			this.umatIstri.pekerjaan = "Konsultan";
			this.umatIstri.pendidikan = "S1";
			this.umatIstri.jurusan = "Teknik Infomatika";
			this.umatIstri.nik = "61287318273";
			this.umatIstri.nohp = "081255225454";
			this.umatIstri.email = "Dayak@gmail.com";
			this.umatIstri.gol_darah = "O";
			this.umatIstri.aktivitas = "Warga Biasa";
			this.umatIstri.profesi = [{ text: "Guru", value: "Guru" }];
			this.umatIstri.keterampilan = [{ text: "Musik", value: "Musik" }];
			this.umatIstri.status_kawin = "Menikah";
			this.umatIstri.cacat_tubuh = "Tidak";

			this.umatPerkawinanItem.no_buku_lm = "12345";
			this.umatPerkawinanItem.no_lm = "54321";
			this.umatPerkawinanItem.tgl_perkawinan = "2020-04-03";
			this.umatPerkawinanItem.keuskupan_lm = "Keuskupan Sintang";
			this.umatPerkawinanItem.paroki_lm =
				"Paroki Katedral Kristus Raja Sintang";
			this.umatPerkawinanItem.wali = this.$faker().name.findName();
			this.umatPerkawinanItem.wali2 = this.$faker().name.findName();
			this.umatPerkawinanItem.imam_peneguh = this.$faker().name.findName();
		},
	},
};
</script>

<template>
	<div>
		<vue-fab
			mainBtnColor="#0071B3"
			:scrollAutoHide="false"
			size="big"
			:globalOptions="{ spacing: 50, delay: 0.05 }"
			icon="menu"
		>
			<fab-item
				@clickItem="handleSumbmit"
				:idx="0"
				title="Simpan"
				icon="save"
			/>
			<fab-item
				@clickItem="autoFill"
				:idx="1"
				title="Auto Fill"
				icon="input"
			/>
		</vue-fab>

		<Breadcrumbs main="Perkawinan" title="Form Perkawinan" />
		<!-- Container-fluid starts-->
		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<form
						@submit.stop.prevent="onSubmit"
						v-if="isLoading"
						id="form-data"
					></form>
					<div>
						<b-card>
							<b-tabs card content-class="mt-3" class="search-list">
								<b-tab title="Umat" active class="text-left">
									<h5 class="mb-2">Data Umat</h5>
									<hr />
									<div
										class="
											form-group
											m-checkbox-inline
											mb-10
											custom-radio-ml
										"
										v-show="mode === 'INSERT'"
									>
										<div class="radio radio-primary d-inline-block">
											<b-form-radio
												name="suamiBaru"
												value="baru"
												v-model="radio.suami"
												>Umat Baru</b-form-radio
											>
										</div>
										<div
											class="radio radio-primary d-inline-block"
											@click="onShowUmatSuami()"
										>
											<b-form-radio
												name="suamiLama"
												value="lama"
												v-model="radio.suami"
												>Umat Lama</b-form-radio
											>
										</div>
									</div>
									<comp-umat-suami
										@validate="validateSuami"
										:triggerValidation="trigger.suami"
									></comp-umat-suami>
								</b-tab>
								<b-tab title="Pasangan" class="text-left">
									<h5 class="mb-2">Data Pasangan</h5>
									<hr />
									<div
										class="
											form-group
											m-checkbox-inline
											mb-10
											custom-radio-ml
										"
									>
										<label>Jenis Data Pasangan : </label>
										<div class="radio radio-success d-inline-block">
											<b-form-radio
												name="relasi"
												:value="true"
												v-model="radio.relasi"
												>Relasi</b-form-radio
											>
										</div>
										<div class="radio radio-danger d-inline-block">
											<b-form-radio
												name="manual"
												:value="false"
												v-model="radio.relasi"
												>Manual</b-form-radio
											>
										</div>
									</div>
									<hr />
									<div
										class="
											form-group
											m-checkbox-inline
											mb-10
											custom-radio-ml
										"
										v-show="radio.relasi"
									>
										<label>Data Umat ? : </label>
										<div class="radio radio-primary d-inline-block">
											<b-form-radio
												name="istriBaru"
												value="baru"
												v-model="radio.istri"
												>Baru</b-form-radio
											>
										</div>
										<div
											class="radio radio-primary d-inline-block"
											@click="onShowUmatIstri()"
										>
											<b-form-radio
												name="istriLama"
												value="lama"
												v-model="radio.istri"
												>Lama</b-form-radio
											>
										</div>
									</div>
									<comp-umat-istri
										@validate="validateIstri"
										:triggerValidation="trigger.istri"
										v-show="radio.relasi"
									></comp-umat-istri>

									<div class="form theme-form" v-show="!radio.relasi">
										<div class="row">
											<div class="col-md-6">
												<div class="form-group">
													<label
														>Nama Pasangan
														<span class="text-danger"
															>*</span
														></label
													>
													<b-form-input
														name="umat_nama"
														v-model="
															dataManual.nama_pasangan
														"
														size="sm"
													></b-form-input>
												</div>
											</div>
										</div>
									</div>
								</b-tab>
							</b-tabs>
						</b-card>
					</div>

					<px-card>
						<div slot="with-padding">
							<h5 class="text-muted">Data Perkawinan :</h5>
							<hr />
							<comp-umat-perkawinan
								@validate="validatePerkawinan"
								:triggerValidation="trigger.perkawinan"
							></comp-umat-perkawinan>
						</div>
					</px-card>
				</div>
			</div>
		</div>

		<modal
			name="umatSuamiModal"
			width="80%"
			height="80%"
			:clickToClose="false"
		>
			<template>
				<div class="myModal">
					<div class="row">
						<div class="col-md-12">
							<b-button-group class="btn-group">
								<b-button
									variant="danger"
									@click="onCancelSuami()"
									v-b-tooltip.hover
									title="Tambah"
									size="sm"
									><i class="fa fa-close"></i> Batal</b-button
								>
							</b-button-group>
							<hr />
						</div>
						<div class="col-md-12">
							<comp-umat-modal @onRowClick="onRowClickSuami" />
						</div>
					</div>
				</div>
			</template>
		</modal>

		<modal
			name="umatIstriModal"
			width="80%"
			height="80%"
			:clickToClose="false"
		>
			<template>
				<div class="myModal">
					<div class="row">
						<div class="col-md-12">
							<b-button-group class="btn-group">
								<b-button
									variant="danger"
									@click="onCancelIstri()"
									v-b-tooltip.hover
									title="Tambah"
									size="sm"
									><i class="fa fa-close"></i> Batal</b-button
								>
							</b-button-group>
							<hr />
						</div>
						<div class="col-md-12">
							<comp-umat-modal @onRowClick="onRowClickIstri" />
						</div>
					</div>
				</div>
			</template>
		</modal>
	</div>
</template>

<style scoped>
.myModal {
	padding: 20px;
	scroll-behavior: smooth;
}
::v-deep .vm--modal {
	overflow-y: auto;
}
.modal-card {
	margin: 0px;
}
</style>